import React from 'react';
import { useSelector } from 'react-redux';
import { GridWrapper } from '@yme/atoms/grid';
import { Image as ImageAtom } from '@yme/atoms/image';
import { getRTL } from '@yme/selectors/common';
import { SELF, BLANK } from '@yme/utils/constants';
import { IndentWrapper } from '../Separator';
import { ElvisImageLink } from './styled';
export function ElvisImage(props) {
    const { alt = '', imageUrl: src, linkUrl = '', caption = '', displayPopupTitle, newTabLink, isCustomGrid, isRemoveBottomIndent, ...rest } = props;
    const isTargetLink = newTabLink ? BLANK : SELF;
    const isRightToLeft = useSelector(getRTL);
    if (!src) {
        return null;
    }
    const attrs = {
        ...rest,
        src,
        alt,
        caption,
        displayPopupTitle,
    };
    const Component = linkUrl ? (React.createElement(ElvisImageLink, { href: linkUrl, target: isTargetLink },
        React.createElement(ImageAtom, { ...attrs, isRightToLeft: isRightToLeft }))) : (React.createElement(ImageAtom, { ...attrs, isRightToLeft: isRightToLeft }));
    if (isCustomGrid) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(GridWrapper, null, Component)));
    }
    return React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent }, Component);
}
ElvisImage.displayName = 'ElvisImage_AENComponent';
